<template>
  <div>
    <div
      v-if="priceMin > 0 && priceMin < 999999"
      class="price-min price"
    >
      <small>{{ $t('object:vacancy.price.perWeekPrepend') }}</small>
      <em>{{ formatCurrency(priceMin, undefined, undefined, formatCurrencyOptions) }}</em>
      <div class="price-period">
        {{ $t('object:vacancy.price.perWeekAppend') }}
      </div>
    </div>
  </div>
</template>
<script>
import getNumberFormat from 'mixins/composition/NumberFormat';

export default {
  name: 'ObjectPricePerWeek',
  props: {
    // min price from the object
    priceMin: {
      type: Number,
      default: 0,
    },
    showDecimals: {
      type: Boolean,
      default: true,
    },
  },
  setup(_, ctx) {
    const { formatCurrency } = getNumberFormat(ctx);
    return { formatCurrency };
  },
  computed: {
    formatCurrencyOptions() {
      const returnVal = {};
      if (!this.showDecimals) {
        returnVal.minimumFractionDigits = 0;
      }
      return returnVal;
    },
  },
  i18nOptions: { namespaces: ['object'] },
};
</script>
